import {Directive, ElementRef, HostListener} from '@angular/core';
import {MatTooltip} from "@angular/material/tooltip";

@Directive({
  selector: '[ellipsisTextTooltip]',
  providers: [MatTooltip]
})
export class EllipsisTextDirective {

  constructor(private matTooltip: MatTooltip , private elementRef : ElementRef) {
    this.elementRef.nativeElement.classList.add('ellipsis-text');
  }

  @HostListener('mouseover') mouseover() {
    if(this.elementRef.nativeElement.offsetWidth < this.elementRef.nativeElement.scrollWidth){
      this.matTooltip.message = this.elementRef.nativeElement.innerText;
      this.matTooltip.show();
    }
  }
  @HostListener('mouseleave') mouseleave() {
    this.matTooltip.hide();
  }

}
